import { render, staticRenderFns } from "./ChipsPopup.vue?vue&type=template&id=8dfc93ae&scoped=true&"
import script from "./ChipsPopup.vue?vue&type=script&lang=js&"
export * from "./ChipsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChipsPopup.vue?vue&type=style&index=0&id=8dfc93ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfc93ae",
  null
  
)

export default component.exports